// Laravel validation errors arrive as { message, errors: { field: [text] } }.

/** The first message for each field, keyed by field name. */
export const getFieldErrors = (error) => {
  const errors = error && error.errors;
  if (!errors || typeof errors !== 'object') {
    return {};
  }
  return Object.keys(errors).reduce((result, field) => {
    const value = errors[field];
    const text = Array.isArray(value) ? value[0] : value;
    return text ? { ...result, [field]: String(text) } : result;
  }, {});
};

export const getErrorMessage = (
  error,
  fallback = 'Something went wrong. Please try again.'
) => {
  const first = Object.values(getFieldErrors(error))[0];
  return first || (error && error.message) || fallback;
};
